window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};


repos.casinoDocumentsRepo = (function () {
    var url = 'api/casinodocuments?c=' + casino.config.guiCacheVerzija;

    var get = function (fileName) {
        return fetch(url + '&fileName=' + fileName)
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);
    };

    return {
        get: get
    };
})();

